// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.smartapplication.PracticeSmartApplicationResponse */
/* istanbul ignore next */
@GandalfModel
export class PracticeSmartApplicationResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	masterSmartApplicationId!: number;

	@GandalfProperty({ designType: String })
	masterSmartApplicationName!: string;

	@GandalfProperty({ designType: String })
	smartApplicationClientIdentifier!: string;

	@GandalfProperty({ designType: String })
	smartApplicationLaunchUrl!: string;

}
